import { Check, X, ArrowRight } from '@phosphor-icons/react';
import { Helmet } from 'react-helmet-async';
import { Breadcrumbs } from '@/components/seo/Breadcrumbs';
import { Link } from '@/lib/router-compat';
import { Card, CardContent } from '@/components/ui/card';


export default function ReguliPublicare() {
  const canonicalUrl = 'https://roautomarket.ro/incredere/reguli-publicare';
  const allowed = [
    'Vehicule reale, cu fotografii proprii',
    'Prețuri corecte, fără artificii de preț',
    'Descrieri oneste cu specificații complete',
    'Date de contact valide',
    'Maxim un anunț per vehicul unic',
  ];
  const forbidden = [
    'Fotografii de pe internet sau generate AI',
    'Prețuri false sau „preț la cerere" pentru a atrage click-uri',
    'Descrieri înșelătoare sau cu km falși',
    'Anunțuri duplicate pentru același vehicul',
    'Conținut discriminatoriu sau ofensator',
    'Vehicule furate sau cu situație juridică neclară',
  ];

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Reguli de Publicare | Ce este permis pe platformă – RO Auto Market</title>
        <meta name="description" content="Regulile de publicare pe RO Auto Market: ce este permis, ce este interzis, standarde de calitate pentru anunțuri auto." />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content="Reguli de Publicare – RO Auto Market" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="article" />
      </Helmet>

      <section className="surface-dark pt-4 pb-6 md:py-10 px-4">
        <div className="container mx-auto max-w-4xl">
          <Breadcrumbs items={[
            { label: 'Trust Center', href: '/incredere' },
            { label: 'Reguli de Publicare', href: '#' }
          ]} className="mb-6" />
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-4">Reguli de Publicare</h1>
          <p className="text-lg text-muted-foreground">Reguli clare pentru anunțuri corecte și transparente pe platformă.</p>
        </div>
      </section>

      <section className="py-12 px-4">
        <div className="container mx-auto max-w-4xl space-y-8">
          <div className="grid md:grid-cols-2 gap-6">
            <Card className="border-primary/20">
              <CardContent className="p-6">
                <h2 className="text-xl font-bold text-foreground mb-4 flex items-center gap-2">
                  <Check className="w-5 h-5 text-primary" /> Ce este permis
                </h2>
                <ul className="space-y-3">
                  {allowed.map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-muted-foreground">
                      <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" /> {item}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
            <Card className="border-destructive/20">
              <CardContent className="p-6">
                <h2 className="text-xl font-bold text-foreground mb-4 flex items-center gap-2">
                  <X className="w-5 h-5 text-destructive" /> Ce este interzis
                </h2>
                <ul className="space-y-3">
                  {forbidden.map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-muted-foreground">
                      <X className="w-4 h-4 text-destructive shrink-0 mt-0.5" /> {item}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          </div>

          <div className="p-6 rounded-lg bg-muted/50">
            <h3 className="font-semibold text-foreground mb-3">Linkuri utile</h3>
            <div className="flex flex-wrap gap-3 text-sm">
              <Link to="/incredere" className="text-primary hover:underline">Trust Center</Link>
              <Link to="/incredere/raporteaza-listare" className="text-primary hover:underline">Raportează o listare</Link>
              <Link to="/incredere/anti-frauda" className="text-primary hover:underline">Politica anti-fraudă</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
